export interface Trend_data1 {
    imgurl : string;
}

let trend1:Trend_data1[] = [
    {
        imgurl : './img/trend/img0.jpg'
    },
    {
        imgurl : './img/trend/img1.jpg'
    },
    {
        imgurl : './img/trend/img2.jpg'
    },
    {
        imgurl : './img/trend/img3.jpg'
    }
]

export default trend1;